module.exports = __webpack_public_path__ + "/images/cover-retailers-box.443eb41.png";